import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { logger } from '../utils/console';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseURL = environment.urlApi;

  constructor(
    private http: HttpClient,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  private getHeaders(): HttpHeaders {
    let token = '';

    // Primeiro verifica se há token salvo no localStorage
    if (localStorage.getItem('accessToken')) {
      token = localStorage.getItem('accessToken');
    }

    // Extrai o parâmetro 'key' da URL atual (suporta URLs com hash #)
    // Usa window.location.href diretamente para garantir acesso à query string
    const fullUrl = window.location.href;
    const queryStringIndex = fullUrl.indexOf('?');
    
    if (queryStringIndex !== -1) {
      const queryString = fullUrl.substring(queryStringIndex + 1);
      // Remove qualquer fragmento (#) que possa aparecer depois dos parâmetros
      const cleanQueryString = queryString.split('#')[0];
      const params = new URLSearchParams(cleanQueryString);
      const keyParam = params.get('key');
      
      if (keyParam) {
        token = keyParam;
        logger.log('[ApiService] ✅ Token extraído da URL (key):', token.substring(0, 50) + '...');
      }
    }

    logger.log('[ApiService] URL completa:', fullUrl);
    logger.log('[ApiService] Token presente:', !!token);
    if (token) {
      logger.log('[ApiService] Token (50 chars):', token.substring(0, 50) + '...');
      logger.log('[ApiService] Authorization header:', 'Bearer ' + token.substring(0, 30) + '...');
    }

    return new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    });
  }

  setAuthorization(token: string): void {
    localStorage.setItem('accessToken', token);
  }

  get baseUrl(): string {
    return this.baseURL;
  }

  get(endpoint: string, params?: any): Observable<any> {
    let queryParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        queryParams = queryParams.set(key, params[key]);
      });
    }
    return this.http.get(this.baseURL + endpoint, {
      headers: this.getHeaders(),
      params: queryParams
    });
  }

  post(endpoint: string, data: any): Observable<any> {
    return this.http.post(this.baseURL + endpoint, data, {
      headers: this.getHeaders()
    });
  }

  patch(endpoint: string, data: any): Observable<any> {
    return this.http.patch(this.baseURL + endpoint, data, {
      headers: this.getHeaders()
    });
  }

  put(endpoint: string, data: any): Observable<any> {
    return this.http.put(this.baseURL + endpoint, data, {
      headers: this.getHeaders()
    });
  }

  delete(endpoint: string, id: string): Observable<any> {
    return this.http.delete(`${this.baseURL}${endpoint}/${id}`, {
      headers: this.getHeaders()
    });
  }
}
